define('shared/initializer/form/newHouseAdapters/mixins/SubscriptionsSavable',[
    '../../constants',
    'shared/lib/RSVP',
    'shared/util/state',
    'shared/util/checkout/emailSubscriptions'
], 
function(
    constants,
    RSVP,
    state,
    emailSubscriptionsUtil
) {
    var MODULAR_NAME = 'SubscriptionsSavable:';

    function lowerFirstWord (word) {
        var lastContinousUpper = -1;
        var charCode; 
        var i;
        var ret = '';
        for(i = 0; i < word.length; i++) {
            charCode = word.charCodeAt(i);
            if (charCode >= 65 && charCode <= 90) {
                lastContinousUpper = i;
            }
            else {
                break;
            }
        }

        if (lastContinousUpper < 0) {
            return word;
        }
        else if (lastContinousUpper === 0) {
            return word.charAt(0).toLowerCase() + word.substr(1);
        }
        else {
            for(i = 0; i < lastContinousUpper; i++) {
                ret += word.charAt(i).toLowerCase();
            }
            ret += word.substr(i);
            return ret;
        }
    }

    function Ctor() {

    }

    Ctor.STATE_KEY = 'session.member.selected.subscriptions';

    Ctor.prototype.doBeforeSubmit = function() {
        var $form = this.$form;

        return RSVP.resolve()
            .then(function(){
                var selectedFields = {};
                emailSubscriptionsUtil.allFields.forEach(function(fieldName){
                    var $input = $form.find('[name="' + fieldName + '"]');

                    if (
                        $input.length <= 0 ||
                        (
                            $input.val() !== 'true' && 
                            $input.val() !== 'on'
                        )
                    ) {
                        return;
                    }

                    if (
                        emailSubscriptionsUtil
                            .mailListFields.indexOf(fieldName) >= 0
                    ) {
                        var $emaiList = 
                            $form
                            .find(
                                '[name="' + 
                                constants.FIELD.EmailList + 
                                '"]'
                            );

                        var valueOfEmailList = ($emaiList.val() || '');
                        var values = valueOfEmailList.split(',');
                        for(var l = values.length; l--;) {
                            switch(values[l]) {
                                case '4':
                                    selectedFields['etPromo'] = true;
                                    break;
                                case '5':
                                    selectedFields['partnerPromo'] = true;
                                    break;
                                case '17':
                                    selectedFields['dailyLesson'] = true;
                                    break;
                            }
                        }
                    }
                    else if (
                        emailSubscriptionsUtil
                            .emailEnglishFields.indexOf(fieldName) >= 0
                    ) {
                        selectedFields['dailyLesson'] = true;
                    }
                    else {
                        var replaced = fieldName.replace('member.SubscribeTo', '');
                        replaced =lowerFirstWord(replaced);
                        selectedFields[replaced] = true;
                    }
                });
                console.log(MODULAR_NAME, 'Saving seletcted fields', selectedFields);
                return state.push(Ctor.STATE_KEY, selectedFields);
            });
    };

    return Ctor;
});
